export default "__VITE_ASSET__Cr7WIOT$__"